import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import {
  Box,
  CenteredContainer,
  Title,
  Type,
  Link,
  Cluster,
} from '@nerdwallet/currency';

import SocialNetworks from '~/client/lib/employee-branding/social-networks';
import styles from './social-media.module.less';

const SocialMedia = () => {
  return (
    <CenteredContainer>
      <Title
        className={classNames([
          classes('margin-horizontal-auto'),
          classes('margin-top-5'),
          classes('margin-bottom-4'),
        ])}
        align="center"
        size="large"
        chronicle
      >
        Get social with us
      </Title>
      <Cluster align="center">
        {SocialNetworks.icons.map((item) => (
          <Link href={item.url} key={item.url} target="_blank">
            <div className={styles.socialNetworkIconItem}>
              <img
                src={item.image}
                width={item.width}
                height={item.height}
                alt={item.alt_text}
              />
            </div>
          </Link>
        ))}
      </Cluster>
      <Box
        className={styles.socialMediaBoxWrapper}
        display="flex"
        justifyContent="center"
      >
        <Box className={styles.socialMediaYoutubeWrapper}>
          <Type size="2" bold gotham>
            Subscribe to our YouTube channel
          </Type>
          <Box
            className={classNames([
              classes('padding-vertical-4--wide'),
              styles.socialMediaPlayerWrapper,
            ])}
          >
            <iframe
              className={styles.socialMediaPlayerContainer}
              title="Nerdwallet Youtube Player"
              src="https://www.youtube.com/embed/JhvolHFzQCc"
              frameBorder="0"
            />
          </Box>
        </Box>
      </Box>
    </CenteredContainer>
  );
};

SocialMedia.propTypes = {};

SocialMedia.displayName = 'SocialMedia';

export default SocialMedia;
